import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { PageGetIp } from '../store/actions/page.actions';
import { environment } from 'src/environments/environment';
import { IAppState } from '../store/state/app.state';
import { Store, select } from '@ngrx/store';
import { VideoService } from '../service/video/video.service';
import { selectIp } from '../store/selectors/page.selectors';

@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.scss']
})
export class VerticalComponent implements OnInit {


  ipObs$ = this._store.pipe(select(selectIp));

  model = {
    cid: null,
    ip: null,
    meeting: null
  };

  @ViewChild('myMedia', { static: true }) myVideo: ElementRef;

  api: VgApiService;

  constructor(
    public videoService: VideoService,
    private _store: Store<IAppState>,
    ) {

  }

  ngOnInit(): void {
    this.ipObs$.subscribe(
      x => {
        if (x && x !== '') {
        this.model.ip = x;
        this.model.meeting = 0;
        if (environment.production) {
          this.model.cid = 'AB396718-9768-406F-8320-BEA0E940CB75';
        } else {
          this.model.cid = '2F1ABD87-5863-4BCA-BEA8-155E4CA42741';
        }

        this.videoService.getVideoUrl(this.model);
      }
      }
    );
    this._store.dispatch(new PageGetIp());
  }

  onPlayerReady(api: VgApiService) {
    this.api = api;
    this.api.getDefaultMedia().subscriptions.canPlayThrough.subscribe(
      () => {
        if (this.myVideo.nativeElement.muted) {
        this.api.volume = 0;
        }
      }
    );
  }



  createLink() {
    if (this.model.ip && this.model.ip !== '') {
    this.videoService.getVideoUrl(this.model);
    }
  }



}
